/* ALL THINGS BIG - shared helper for the Big Boy TV video pool (assets/bbb-pool.json).
   Used by sections/bbb-video-gallery.liquid (/pages/videos) and sections/bbb-watch.liquid (home reel).
   Thumbnails stay behind the visitor's choice: images are only given a src when assets/bbb-consent.js has
   switched html[data-bbb-yt="on"]; otherwise they keep data-bbb-src and consent.js loads them later. */
(function () {
  if (window.bbbPool) return;
  var cache = {};
  function load(url) {
    if (!cache[url]) cache[url] = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('pool ' + r.status); return r.json(); });
    return cache[url];
  }
  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  /* Random order in which no two neighbours (and, when possible, no two within three tiles) share a category. */
  function seq(items) {
    function build() {
      var by = {}, keys = [], out = [], recent = [], left = items.length;
      items.forEach(function (n) { var c = n.cat; if (!by[c]) { by[c] = []; keys.push(c); } by[c].push(n); });
      keys.forEach(function (k) { by[k] = shuffle(by[k]); });
      while (left) {
        var w = 3, pick = [];
        while (w >= 0 && !pick.length) {
          var r = recent.slice(Math.max(0, recent.length - w));
          pick = keys.filter(function (k) { return by[k].length && r.indexOf(k) < 0; });
          w--;
        }
        var c = null;
        pick.forEach(function (k) { if (by[k].length * 2 - 1 >= left) c = k; });
        if (c === null) {
          var tot = 0; pick.forEach(function (k) { tot += by[k].length * by[k].length; });
          var x = Math.random() * tot;
          pick.forEach(function (k) { if (c === null) { x -= by[k].length * by[k].length; if (x <= 0) c = k; } });
          if (c === null) c = pick[pick.length - 1];
        }
        out.push(by[c].pop()); recent.push(c); left--;
      }
      return out;
    }
    function score(a) { var s = 0; for (var i = 1; i < a.length; i++) { if (a[i].cat === a[i - 1].cat) s += 10; if (i > 1 && a[i].cat === a[i - 2].cat) s += 1; } return s; }
    var best = null, bs = 1e9;
    for (var t = 0; t < 25 && bs > 0; t++) { var a = build(), s = score(a); if (s < bs) { bs = s; best = a; } }
    return best;
  }
  function fmt(s) {
    s = Math.round(s); var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return h ? h + ':' + p(m) + ':' + p(x) : m + ':' + p(x);
  }
  function thumbsOn() { return document.documentElement.getAttribute('data-bbb-yt') === 'on'; }
  /* kind: 'max' (maxresdefault, falls back to hqdefault; hq=true goes straight to hqdefault for videos with no maxres) or 'mq' (mqdefault) */
  function thumb(id, kind, alt, hq) {
    var img = document.createElement('img'), base = 'https://i.ytimg.com/vi/' + id + '/';
    var url = base + (kind === 'max' ? (hq ? 'hqdefault' : 'maxresdefault') : 'mqdefault') + '.jpg', fb = kind === 'max' && !hq ? base + 'hqdefault.jpg' : '';
    img.width = kind === 'max' ? 1280 : 320; img.height = kind === 'max' ? 720 : 180; img.alt = alt || ''; img.decoding = 'async';
    if (kind === 'max') img.loading = 'lazy';
    function swap() { if (fb) { var u = fb; fb = ''; img.src = u; } }
    img.addEventListener('load', function () { if (img.naturalWidth <= 120) swap(); });
    img.addEventListener('error', swap);
    if (thumbsOn()) { img.referrerPolicy = 'no-referrer'; img.src = url; } else img.setAttribute('data-bbb-src', url);
    return img;
  }
  /* n videos for the home reel: never one already shown earlier in this browser session (until the pool runs out). */
  function pickFresh(videos, n) {
    var key = 'bbbSeen', seen = [];
    try { seen = JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (e) {}
    var fresh = videos.filter(function (v) { return seen.indexOf(v.id) < 0; });
    var chosen;
    if (fresh.length >= n) { chosen = seq(shuffle(fresh)).slice(0, n); seen = seen.concat(chosen.map(function (v) { return v.id; })); }
    else {
      var rest = shuffle(videos.filter(function (v) { return seen.indexOf(v.id) >= 0; })).slice(0, n - fresh.length);
      chosen = fresh.concat(rest); seen = chosen.map(function (v) { return v.id; });
    }
    try { sessionStorage.setItem(key, JSON.stringify(seen)); } catch (e) {}
    return seq(chosen);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML.replace(/"/g, '&quot;'); }
  var api = { load: load, shuffle: shuffle, seq: seq, fmt: fmt, thumb: thumb, pickFresh: pickFresh, esc: esc };
  window.bbbPool = api;
  var q = window.bbbPoolQ; window.bbbPoolQ = { push: function (f) { f(api); } };
  if (q && q.length) q.forEach(function (f) { f(api); });
})();
